export default __webpack_public_path__ + "static/16-86dc4097a253dbf362d816d858609422.jpg";